import { render, staticRenderFns } from "./CommunityFollowBtn.vue?vue&type=template&id=5df8dee4&"
import script from "./CommunityFollowBtn.vue?vue&type=script&lang=ts&"
export * from "./CommunityFollowBtn.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityFollowBtn.vue?vue&type=style&index=0&id=5df8dee4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports